export const formatUSPhone = (value: string | number) => {
  if (!value) return "";

  const digits = value.toString().replace(/\D/g, "").slice(0, 10);

  if (digits.length < 4) return digits;
  if (digits.length < 7)
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const getUSPhoneDigits = (value: string) =>
  value.replace(/\D/g, "").slice(0, 10);

export const handleUSPhoneChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  setValue: (digits: string) => void
) => {
  const input = e.target;
  const raw = input.value;
  const cursor = input.selectionStart || 0;

  const digitsBeforeCursor = raw
    .slice(0, cursor)
    .replace(/\D/g, "").length;

  const digits = getUSPhoneDigits(raw);

  setValue(digits);

  requestAnimationFrame(() => {
    const formatted = formatUSPhone(digits);

    let newCursor = formatted.length;
    let digitCount = 0;

    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) digitCount++;

      if (digitCount === digitsBeforeCursor) {
        newCursor = i + 1;
        break;
      }
    }

    input.setSelectionRange(newCursor, newCursor);
  });
};